import { isCalendarDateString } from './is-calendar-date-string.js';
export function valueMatchesKind(value, kind) {
    switch (kind) {
        case 'boolean':
            return typeof value === 'boolean';
        case 'number':
            return typeof value === 'number';
        case 'string':
            return typeof value === 'string';
        case 'date':
            return isCalendarDateString(value);
        case 'none':
            return true;
    }
}
//# sourceMappingURL=value-matches-kind.js.map